import { createWebHistory, createRouter } from "vue-router";
import NotFoundSection from "@/components/NotFoundSection.vue";
import VisitanteSection from "@/components/VisitanteSection.vue";
import CredencialSection from "@/components/CredencialSection.vue";
import PrensaSection from "@/components/PrensaSection.vue";
import ExpositorSection from "@/components/ExpositorSection.vue";

const routes = [
  {
    path: "/",
    component: VisitanteSection,
  },
  {
    path: "/expositores",
    component: ExpositorSection,
  },
  {
    path: "/prensa",
    component: PrensaSection,
  },
  {
    path: "/credenciales",
    component: CredencialSection,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFoundSection,
  },  
];

import { createWebHashHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

export default router;